import React from 'react';
import { SvgIcon } from '@mui/material';

function StarIcon({ color = '#757575', ...props }) {
  return (
    <SvgIcon viewBox="0 0 64 64" sx={{ width: 20, height: 20 }} {...props}>
      <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect opacity="0.15" x="2.74756" y="2" width="20" height="20" rx="4" fill={color} />
        <g clipPath="url(#clip0_1280_30)">
          <path d="M10.8084 9.28162L7.08674 9.82121L7.02082 9.83462C6.92103 9.86111 6.83007 9.91361 6.75721 9.98676C6.68435 10.0599 6.6322 10.1511 6.60611 10.251C6.58001 10.3509 6.58088 10.4559 6.60865 10.5553C6.63642 10.6548 6.69008 10.745 6.76415 10.817L9.46032 13.4414L8.82449 17.1485L8.8169 17.2126C8.81079 17.3158 8.83222 17.4188 8.879 17.511C8.92577 17.6032 8.99621 17.6813 9.0831 17.7373C9.16999 17.7934 9.2702 17.8253 9.37349 17.8299C9.47677 17.8344 9.57941 17.8114 9.6709 17.7633L12.9994 16.0133L16.3203 17.7633L16.3787 17.7901C16.4749 17.828 16.5796 17.8397 16.6818 17.8238C16.7841 17.808 16.8803 17.7652 16.9606 17.6999C17.0409 17.6345 17.1023 17.5491 17.1386 17.4522C17.175 17.3553 17.1849 17.2504 17.1673 17.1485L16.5309 13.4414L19.2282 10.8164L19.2737 10.7668C19.3387 10.6867 19.3813 10.5909 19.3972 10.489C19.4131 10.3871 19.4017 10.2828 19.3642 10.1868C19.3267 10.0908 19.2644 10.0064 19.1836 9.94225C19.1028 9.87813 19.0065 9.83657 18.9045 9.82179L15.1828 9.28162L13.5192 5.90995C13.471 5.81227 13.3965 5.73001 13.304 5.67248C13.2115 5.61496 13.1048 5.58447 12.9959 5.58447C12.887 5.58447 12.7803 5.61496 12.6878 5.67248C12.5953 5.73001 12.5208 5.81227 12.4727 5.90995L10.8084 9.28162Z" fill={color} />
        </g>
        <defs>
          <clipPath id="clip0_1280_30">
            <rect width="14" height="14" fill={color} transform="translate(6 5)" />
          </clipPath>
        </defs>
      </svg>

    </SvgIcon>
  );
}
export default StarIcon;
